import { call, fork } from 'redux-saga/effects';
import { delay } from '../utils.js';

// Light colored dots, for use on dark backgrounds
export const ANIMATED_DOTS =
    `<span class="js-animating">
        <span class="u-animated-light"></span>
        <span class="u-animated-light"></span>
        <span class="u-animated-light"></span>
     </span>`;

// Dark dots, for use on light backgrounds
export const ANIMATED_DOTS_DARK =
    `<span class="js-animating">
        <span class="u-animated-dark"></span>
        <span class="u-animated-dark"></span>
        <span class="u-animated-dark"></span>
     </span>`;

export const ANIMATED_DOTS_SMALL_DARK =
    `<span class="js-animating">
        <span class="u-animated-small-dark"></span>
        <span class="u-animated-small-dark"></span>
        <span class="u-animated-small-dark"></span>
     </span>`;

/**
 * Change a button's text while running a saga.  This essentially wraps
 *  a saga in a block
 *
 * @param callEffect - What saga *effect* to run.  You should pass a *call* object.
 *   ie: const callSaga = call(sagaToRun, options, options, options)
 * @param {mixed} selectorOrNode - Selector to the buttons span or DOM element
 * @param delayTime - How long to wait, in milliseconds
 * @param options.pendingClass - CSS class to add while the saga is executing
 * @param options.pendingText - What text to change to while the saga is executing
 * @param options.changeToText - What text to change to once the action in finished
 * @param options.changeBackText - Optional. What to change the text back to.  Optional.  If not
 *   set, defaults to original button text
 */
export function *updateButtonTextSaga(callEffect, selectorOrNode, delayTime, options = {}) {
    const target = $(selectorOrNode);

    function removePending() {
        if (options.pendingClass) {
            target.removeClass(options.pendingClass);
        }

        target.find('.js-animating').remove();
    }

    function *successSaga() {
        yield call(delay, delayTime);
        removePending();
        target.text(options.changeBackText);
    }

    let sagaResult;

    if (target.length > 0) {
        if (!options.changeBackText) {
            options.changeBackText = target.text();
        }

        try {
            if (options.pendingClass) {
                target.addClass(options.pendingClass);
            }

            target.text('');
            target.html(options.pendingText || ANIMATED_DOTS);

            sagaResult = yield callEffect;

            removePending();

            target.text(options.changeToText);

            if (options.successClass) {
                target.parent().addClass(options.successClass);
            }

            yield fork(successSaga);
        } catch (error) {
            removePending();
            target.text(options.changeBackText);
            target.parent().removeClass(options.successClass);
            throw error;
        }
    } else {
        sagaResult = yield callEffect;
    }

    return sagaResult;
}
